























































import Vue from 'vue';
import { FirebaseLesson } from '@/store/types';
import BbTools from '@/tools/bluebird';
import UserTools from '@/tools/user';

export default Vue.extend({
  computed: {
    bookmarks(): Array<FirebaseLesson> {
      return this.$store.state.userLessons
        .filter((item: FirebaseLesson) => item.isBookmark === true);
    },
  },
  methods: {
    getBookmarkImage(image: string): string {
      if (image.indexOf('?app=') === -1) {
        return `${image}${BbTools.APP_POSTFIX}`;
      }
      return image;
    },
    async onDelete(lesson: FirebaseLesson): Promise<void> {
      await UserTools.deleteBookmark(this.$store, lesson);
      await UserTools.loadUserLessons(this.$store, this.$store.state.user.uid);
    },
  },
});
